import { Button, CloseIcon, Dialog, Flex, Text, Tooltip } from "@fluentui/react-northstar";
import { memo, useMemo } from "react";
import { primaryStyle } from "../../../../utils/primaryStyle";
import { useDeleteGroup } from "./DeleteGroup.logic";
import { shouldTruncate } from "front";

const DeleteGroup = memo(() => {
  const logic = useDeleteGroup();

  const renderContent = useMemo(
    () => (
      <div style={{ padding: "1rem 0" }}>
        <Text content={logic.t("DeleteGroupMessage")}></Text>{" "}
        <Tooltip content={logic.name} trigger={<Text content={shouldTruncate(logic.name, 20) ? `${logic.name.substring(0, 20)}...` : logic.name} weight="bold" />} />
        <Text content={logic.locale === "en" ? "?" : " ?"} />
      </div>
    ),
    []
  );

  const renderFooter = useMemo(
    () => (
      <>
        <Flex hAlign="end">
          <Button disabled={logic.isLoading} content={logic.t("Cancel")} style={{ marginRight: ".5rem" }} onClick={logic.handleClose} />
          <Button disabled={logic.isLoading} primary style={primaryStyle} content={logic.t("Delete")} onClick={logic.handleDelete} />
        </Flex>
      </>
    ),
    [logic.isLoading]
  );

  return (
    <Dialog
      header={logic.t("DeleteGroup")}
      headerAction={{ icon: <CloseIcon />, title: "Close", onClick: logic.handleClose }}
      content={renderContent}
      footer={renderFooter}
      defaultOpen={true}
      onCancel={logic.handleClose}
      closeOnOutsideClick
    />
  );
});

export default DeleteGroup;
